import { Box, Heading, Text } from '@betterment/samba-react';

import { ForwardSignatureDialog, ForwardSignatureDialogProps } from './ForwardSignatureDialog';

export const ForwardSignature: React.FC<React.PropsWithChildren<ForwardSignatureDialogProps>> = ({
  signablePackageId,
  onForwardingComplete,
}) => {
  return (
    <Box
      css={{ mb: 'space.400', p: 'space.300', borderStyle: 'solid', borderWidth: 'thin', borderColor: 'border.weak' }}
    >
      <Box css={{ display: 'flex' }}>
        <Box css={{ flexGrow: '1' }}>
          <Heading variant="title100">Not the contract signer?</Heading>
          <Text>Forward this document to the person who needs to sign.</Text>
        </Box>
        <ForwardSignatureDialog signablePackageId={signablePackageId} onForwardingComplete={onForwardingComplete} />
      </Box>
    </Box>
  );
};
